import Control from "../1. Core/Control";
import TopAppBar from "../1. Core/Controls/TopAppBar/TopAppBar";
import DataTable from "../1. Core/Controls/DataTable/DataTable";
import Menu from "../1. Core/Controls/Menu/Menu";
import {PushSchedule} from "./Users/types";
import NP, {EventArgs} from "../1. Core/NP";
import EditPushScheduleDlg from "./Users/EditPushScheduleDlg";
import {ListBoxItemArgs} from "../1. Core/Controls/ListBox/ListBox";
import {ServerAPI} from "../1. Core/ServerAPI";


export default class PushScheduleList extends Control {
    private _Offset: number;
    private _Count: number;
    private _FilterText: string;
    private _topAppBar: TopAppBar;
    private _list: DataTable;
    public _contextMenu: Menu;


    constructor(settings?: object) {
        super(settings);
        this._render();
    }

    _initFields(settings: object) {

        super._initFields(settings);
    }

    _render() {
        this.np_render();

        this._Offset = 0;
        this._Count = 100;
        this._FilterText = "";
        this._topAppBar = new TopAppBar({
            Caption: 'Push schedule',
            ParentNode: this._root,
            Class: 'top-app-bar--no-shadow top-app-bar--light library-box-list__app-bar',
            ShowSearchButton: true,
            RightItems: [{
                ToolTip: NP.RM.getString('AddSingleUser'),
                FontImage: NP.FontImages.add,
                EvClick: () => {
                    (new EditPushScheduleDlg({
                        Item: {
                            Title: 'New Schedule',
                            Body: 'New Schedule',
                            pushTS: '2024-01-01 00:00:00.0',
                            filter: {}
                        },
                        EvClosed: () => this.refresh()
                    })).show()
                }
            }]
        });


        let columns = [{
            Content: "title",
            PropertyContent: 'title',
            Width: '300px'
        }, {
            Content: 'Scheduled Date Time UTC',
            PropertyContent: 'pushTS',
            Width: '200px'
        }, {
            Content: 'Sended Date Time UTC',
            PropertyContent: 'sendedTS',
            Width: '300px'
        }]


        this._list = new DataTable({
            ParentNode: this._root,
            EnableSort: false,
            Class: 'app-list--avatars',
            ShowSettingsButton: true,
            Columns: columns,
            EvItemClick: (s: object, e: { Item: PushSchedule }) => {
                (new EditPushScheduleDlg({
                    Item: e.Item
                })).show()
            },
            EvItemContextMenu: (sender: Control, args: EventArgs) => {
                this._getContextMenu().setData(args.Item);
                this._getContextMenu().showContextMenu(args.Event);
            }
        });
    }


    getTopAppBar() {
        return this._topAppBar;
    }

    _getContextMenu() {
        let items = [{
            RK: 'Edit',
            Value: 'Edit'
        }, {
            RK: 'Delete',
            Value: 'Delete'
        }];


        return this._contextMenu || (this._contextMenu = new Menu({
            Items: items,
            EvItemSelected: this._onSettingsMenuItemSelected.bind(this)
        }))
    }


    async _onSettingsMenuItemSelected(sender: Menu, args: ListBoxItemArgs) {
        const item = sender.getData() as PushSchedule;
        switch (args.Item.getValue()) {
            case 'Edit':
                (new EditPushScheduleDlg({
                    Item: item
                })).show()
                break;
            case 'Delete':
                NP.showConfirm({
                    Content: 'Are you sure you want to delete this item?',
                    EvOkButtonClick: () => ServerAPI.delet(`/push-schedule/${item.id}`)
                        .then(() => this.refresh())
                });
                break;
        }
    }


    setHeight(value: number) {
        super.setHeight(value);
        if (this._list)
            this._list.setHeight(this._Height - 64);
    }

    setWidth(value: number) {
        super.setWidth(value);

        if (this._list)
            this._list.setWidth(value);
    }

    filterItems(value: string) {
        this._FilterText = value;
        this.refresh();
    }

    async refresh() {
        let res = await ServerAPI.get<PushSchedule[]>("/push-schedule")
        this._list.setRows(res);
    }
}
